import { DefaultIcon, ControlValve, CustomerPoints, Fitting, FixedHead, FloatValve, FlowMeter, Hydrants, Junction, Lamphole, Manhole, ManholeSurvey, Cleanout, NonReturnValves, Pump, PumpStation, Reservoir, Sensor as SensorIcon, Tank, Valves, Wells, Defects, Station, StationOpenRoof, Pipe, PipeIndirect, Influent, Blower, GravityBelt, WaterTreatment, StorageTank, Seperator, Clarifier, ScrewPress, BarScreen, ChlorinationTank, Membrane, Filter, } from '@innovyze/stylovyze/lib/icons/SensorIcons';
/**
 * Deprecated, will be removed soon after updating all consuming modules
 */
export const iconTypes = {
    Default: DefaultIcon(),
    'Control Valve': ControlValve(),
    'Customer Points': CustomerPoints(),
    Fitting: Fitting(),
    'Fixed Head': FixedHead(),
    'Float Valve': FloatValve(),
    'Flow Metre': FlowMeter(),
    Hydrants: Hydrants(),
    Junction: Junction(),
    Lamphole: Lamphole(),
    Manhole: Manhole(),
    'Manhole survey': ManholeSurvey(),
    Cleanout: Cleanout(),
    'Non-Return Valves': NonReturnValves(),
    Pump: Pump(),
    'Pump Station': PumpStation(),
    Reservoir: Reservoir(),
    Sensor: SensorIcon(),
    Tank: Tank(),
    Valves: Valves(),
    Wells: Wells(),
    Defects: Defects(),
    Station: Station(),
    'Station Variation Open Roof': StationOpenRoof(),
    Pipe: Pipe(),
    'Pipe (Indirect Connection)': PipeIndirect(),
    'Influent/Effluent': Influent(),
    Blower: Blower(),
    'Gravity Belt': GravityBelt(),
    'Water Treatment Works': WaterTreatment(),
    'Storage Tank': StorageTank(),
    Seperator: Seperator(),
    Clarifier: Clarifier(),
    'Screw Press': ScrewPress(),
    'Bar Screen': BarScreen(),
    'Chlorination Tank': ChlorinationTank(),
    Membrane: Membrane(),
    Filter: Filter(),
};
export var RectangleButtonTypes;
(function (RectangleButtonTypes) {
    RectangleButtonTypes["TEXT"] = "TEXT_ONLY";
    RectangleButtonTypes["DEFAULT"] = "DEFAULT";
    RectangleButtonTypes["REAL_TIME_VALUE"] = "REAL_TIME_VALUE";
})(RectangleButtonTypes || (RectangleButtonTypes = {}));
export var DISPLAY_STYLE;
(function (DISPLAY_STYLE) {
    DISPLAY_STYLE["STACKED"] = "Stack";
    DISPLAY_STYLE["INLINE"] = "Inline";
})(DISPLAY_STYLE || (DISPLAY_STYLE = {}));
